import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FryCommonModule } from '@fry/components/common';

import { MaterialModule } from '@fry/components/material';
import { UnboxedModule } from '@fry/ui';
import { GeneralListComponent } from './general-list/general.list.component';
import { GeneralRoutingModule } from './general-routing.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    MaterialModule,
    UnboxedModule,
    GeneralRoutingModule,
  ],
  declarations: [
    GeneralListComponent,
  ],
  exports: [
    GeneralListComponent
  ],
  providers: [
  ],
})
export class GeneralModule {}
